export class ViewPort {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  isAbove1200pixels: boolean;
}
